import createAction from '@wix/communities-blog-client-common/dist/src/services/create-action';
import { normalizePost } from '../services/post-utils';
import { getCategoryIds } from '../selectors/categories-selectors';
import { debug } from '../services/debug';
import { updatePostSuccess } from './update-post';

export const SCHEDULE_POST_REQUEST = 'post/SCHEDULE_POST_REQUEST';
export const SCHEDULE_POST_SUCCESS = 'post/SCHEDULE_POST_SUCCESS';
export const SCHEDULE_POST_FAILURE = 'post/SCHEDULE_POST_FAILURE';

export const schedulePostRequest = createAction(SCHEDULE_POST_REQUEST);
export const schedulePostSuccess = createAction(SCHEDULE_POST_SUCCESS);
export const schedulePostFailure = createAction(SCHEDULE_POST_FAILURE);

export const schedulePost = (postId, scheduledPublishDate) => (dispatch, getState, { request }) => {
  dispatch(schedulePostRequest());

  const promise = request.post(`/_api/posts/${postId}/schedule`, {
    scheduledPublishDate,
  });

  return promise
    .then(post => {
      const normalizedPost = normalizePost({ post, blogCategoryIds: getCategoryIds(getState()) });
      dispatch(schedulePostSuccess(normalizedPost));
      dispatch(updatePostSuccess(normalizedPost));
    })
    .catch(error => {
      debug.error(error);
      return dispatch(schedulePostFailure(error));
    })
    .then(() => promise);
};
